import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import './LogoAnimation.css';

const pieces = [
  { id: 'top', src: '/heliqon_helix.svg' },
];

export default function LogoAnimation() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.logo-piece',
        {
          opacity: 0,
          y: -200, // Start off-screen above
        },
        {
          opacity: 1,
          y: 0, // Drop to its original position
          duration: 1,
          delay: 0.3,
          ease: "power2.out", // Accelerates and decelerates smoothly
        }
      );

      // Remove the animation for the text logo
      // gsap.fromTo(
      //   '.text-logo',
      //   {
      //     opacity: 0,
      //     y: 50, // Start slightly below
      //   },
      //   {
      //     opacity: 1,
      //     y: 0, // Move to its original position
      //     duration: 0.8,
      //     delay: 1.5, // Start after the SVG animation completes
      //     ease: "power2.out",
      //   }
      // );
    }, containerRef);

    return () => ctx.revert(); // cleanup
  }, []);

  return (
    <div className="logo-container" ref={containerRef}>
      <div className="logo-piece-container">
        {pieces.map((piece) => (
          <img
            key={piece.id}
            src={piece.src}
            className="logo-piece"
            alt={`Logo piece ${piece.id}`}
          />
        ))}
      </div>
      <img
        src="/heliqon_textonly_400px.png"
        className="text-logo"
        alt="Heliqon Text Logo"
      />
    </div>
  );
}